module.exports = __webpack_public_path__ + "static/media/mailcommsgroup-white.14bd8eff.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mailcommsgroup-white.png
// module id = 660
// module chunks = 0